import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { QUERY_RETRY, QUERY_STALE_TIME_MS } from '../constants'
import type { SanityHubWithArticles } from '../interfaces'
import type { SanityLanguage } from '../services/sanityLanguage'
import { toSanityLanguage } from '../services/sanityLanguage'
import { getHubsWithArticles } from '../services/sanityQueries'

interface UseResourceHubsResult {
  hubs: SanityHubWithArticles[]
  language: SanityLanguage
  isLoading: boolean
  isError: boolean
}

export const useResourceHubs = (): UseResourceHubsResult => {
  const { i18n } = useTranslation()
  const language = toSanityLanguage(i18n.language)

  const { data, isLoading, isError } = useQuery(
    ['resource-center', 'hubs', language],
    () => getHubsWithArticles(language),
    { staleTime: QUERY_STALE_TIME_MS, refetchOnWindowFocus: false, retry: QUERY_RETRY },
  )

  return { hubs: data ?? [], language, isLoading, isError }
}
